export enum ShelfScenesEnum {
  PERSPECTIVE = 'perspective',
  FRONTAL = 'frontal',
  CUSTOM = 'custom',
}
